module.exports = __webpack_public_path__ + "img/logo3.7950a1e0.svg";